export default {
  campaign: {
    include: 'AssetGroup.Assets',
  },
  campaignUser: {
    include: 'User.AssetGroup.Assets',
  },
}
